<template>
  <div>
    <nav class="ng-nav main-color-border">
      <div class="w1200">
        <div class="ng-all-category" v-on:mouseleave="hiddencategory()">
          <div class="ng-ac-title" v-on:mouseenter="showcategory()">
            <a href="javascript:;"
              ><i class="fa fa-list" aria-hidden="true"></i
            ></a>
          </div>
          <div
            v-show="isshow"
            style="width:1200px;position:absolute;padding-top:15px;"
          >
            <div class="pn-category">
              <div class="pn-category-menu">
                <ul class="pn-menu">
<li
                      class="pn-menulist"
                      v-for="(list, index) in classlist"
                      :key="index"
                      v-on:mouseenter="showsubclass(index)"
                      v-on:mouseleave="hiddensubclass(index)"
                    >
                      <div class="pn-class">
                        <div class="pn-classname">
                          <p class="pn-span1">
                            <el-image class="span1-img" :src="list.d_gc_image">
                              <div slot="error" class="image-slot">
                                <img class="span1-img" :src="imgUrlLittle" />
                              </div>
                            </el-image>
                            <a
                              :href="
                                CurrentEnvPrefix.search +
                                  '/?d_gc_id=' +
                                  list.d_gc_id
                              "
                              >{{ list.d_gc_name }}</a
                            >
                          </p>
                        </div>
                        <div class="pn-second" v-if="list.cn_classs && list.cn_classs.length">
                          <a
                            v-for="s in list.cn_classs"
                            :key="s.d_gc_id"
                            :href="
                              CurrentEnvPrefix.search +
                                '/?d_gc_id=' +
                                s.d_gc_id
                            "
                            >{{ s.d_gc_name }}</a
                          >
                        </div>
                      </div>
                      <div class="pn-subclass" v-show="isshow1 == index">
                        <div class="pn-subclass-main">
                          <div class="pn-subclass-content">
                            <ul
                              class="pn-sc-list"
                              v-if="hasThirdChild(list)"
                            >
                              <li
                                class="pn-sc-item"
                                v-for="slist in list.children"
                                :key="slist.d_gc_id"
                              >
                                <a
                                  :href="
                                    CurrentEnvPrefix.search +
                                      '/?d_gc_id=' +
                                      slist.d_gc_id
                                  "
                                  class="pn-scname1"
                                  >{{ slist.d_gc_name }}</a
                                >
                                <ul class="pn-sc-ul">
                                  <li
                                    class="pn-sc-li"
                                    v-for="sclass in slist.children"
                                    :key="sclass.d_gc_id"
                                  >
                                    <a
                                      :href="
                                        CurrentEnvPrefix.search +
                                          '/?d_gc_id=' +
                                          sclass.d_gc_id
                                      "
                                      >{{ sclass.d_gc_name }}</a
                                    >
                                  </li>
                                </ul>
                              </li>
                            </ul>
                            <ul class="pn-sc-ul" v-else>
                              <li
                                class="pn-sc-li"
                                v-for="slist in list.children"
                                :key="slist.d_gc_id"
                              >
                                <a
                                  :href="
                                    CurrentEnvPrefix.search +
                                      '/?d_gc_id=' +
                                      slist.d_gc_id
                                  "
                                  >{{ slist.d_gc_name }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    </div>
                  </template>
                </ul>
              </div>
              <div class="pn-store">
                <div class="pn-storelist">
                  <swiper
                    :options="swiperOption"
                    ref="mySwiper"
                    style="height:235px;"
                  >
                    <!-- slides -->
                    <swiper-slide
                      v-for="(list, index) in shoplist"
                      :key="index"
                    >
                      <a :href="list.ads[0].url" target="_blank">
                        <img :src="list.ads[0].pic" />
                        <p style="text-align:center;margin-top:10px;">
                          {{ list.store_name }}
                        </p>
                        <p style="text-align:center;width: 256px;">
                          <span
                            style="border:1px solid #FF3838;color:#ff3838;width:82px;height:20px;display:inline-block;text-align:center;line-height:20px;border-radius:12px"
                            >新晋商家</span
                          >
                        </p>
                      </a>
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div
                      class="swiper-pagination"
                      slot="pagination"
                      style="bottom:0;"
                    ></div>
                    <!-- <div class="swiper-button-prev  swiper-button-white" slot="button-prev" @click='slidePrev()'></div>
									    <div class="swiper-button-next  swiper-button-white" slot="button-next" @click='slideNext()'></div> -->
                  </swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul class="site-menu">
          <li>
            <a
              href="javascript:void(0)"
              @click="
                hrefClick(CurrentEnvPrefix.main + Common.getSourec().sitehost)
              "
              >首页</a
            >
          </li>
          <li>
            <a
              href="/seasongoods?spm=act.pages.nav.seasonnewgoods"
              target="_blank"
              ref="cxxp"
              >春夏新品</a
            >
          </li>
          <!-- <li><a href="/hotstore?spm=act.pages.nav.hotstore" target="_blank" ref="hotstore">人气商家</a></li> -->
          <!-- <li><a href="/purchase?spm=act.pages.nav.purchase" target="_blank" ref="wjcgj">旺季采购节</a></li> -->
          <!-- <li><a href="/topsupplier?spm=act.pages.nav.topsupplier" target="_blank" ref="sjyz">十佳供应商</a></li>
					<li><a href="/goodsupplier?spm=act.pages.nav.goodsupplier" target="_blank" ref="yzsj">优质供应商</a></li> -->
          <!-- <li><a href="/newtowel?spm=act.pages.nav.seasonnewgoods" target="_blank" ref="towel">毛巾新品</a></li> -->
          <!-- <li><a href="/jiafangcheng?spm=act.pages.nav.jiafangcheng" target="_blank" ref="jiafangcheng">三期市场</a></li> -->
          <!-- <li><a href="/zhounian?spm=act.pages.nav.zhounian" target="_blank" ref="zhounian">周年主推</a></li> -->
          <!-- <li><a href="/newgoods?spm=act.pages.newgoods" target="_blank" ref="xbpa">新帮派</a></li>
					<li><a href="/hotsearch?spm=act.pages.hotsalesgoods" target="_blank" ref="rbpa">热帮派</a></li> -->
          <!-- <li><a href="/brand?spm=act.pages.brands" target="_blank" ref="ppya">优选商家</a></li> -->
          <!-- <li><a href="/videolist?spm=act.pages.videolist" target="_blank" ref="videolist">视频空间</a></li> -->
          <!-- <li><a href="/articlelist?spm=act.pages.nav.articlelist" target="_blank" ref="articlelist">品牌营</a></li> -->
          <!-- <li><a href="/channel?spm=act.pages.nav.channel" target="_blank" ref="channel">市场导航</a></li> -->
          <!-- <li><a href="/navigation?spm=act.pages.nav.all" target="_blank" ref="cja">市场导航</a></li> -->
          <!-- <li><a href="/wetchat?spm=act.pages.nav.wechat" target="_blank" ref="wsa">微商导航</a></li> -->
          <!-- <li><a href="/findgoods?spm=act.pages.nav.findgoods" target="_blank" ref="fxhh">发现好货</a></li> -->

          <!-- <li><a href="/tianmao?spm=act.pages.nav.tianmao" target="_blank" ref="tm">喵好店</a></li> -->
          <!-- <li><a href="/yiqing?spm=act.pages.nav.yiqing" target="_blank" ref="yiqing">疫情助力</a></li>
					<li><a href="/repeatwork?spm=act.pages.nav.repeatwork" target="_blank" ref="repeatwork">复工统计</a></li> -->
        </ul>
        <!-- <div class="ng-nav-tel">
					<span class="ng-tel-title">服务热线：</span>
					<span class="ng-tel-nub">400-0513-256</span>
				</div> -->
      </div>
    </nav>
  </div>
</template>

<style type="text/css" scoped>
.site-menu .router-link-exact-active.router-link-active {
  color: #ff2d51;
}
.swiper-slide {
  float: left;
}
.swiper-button-white {
  display: none;
  width: 20px;
  height: 20px;
  background-size: 100%;
  top: 56%;
}
.pn-store:hover .swiper-button-white {
  display: block;
}
.pn-category .pn-span2 {
  display: block;
  height: 26px;
  line-height: 40px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 260px;
}
.pn-category .span1-img {
  width: 20px;
  height: 20px;
}
.pn-category .pn-span1 a {
  margin-left: 5px;
}
.pn-second {
  margin-top: 4px;
  height: 18px;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
  color: #999;
}
.pn-second a {
  color: #999;
  margin-right: 8px;
}
.pn-second a:hover {
  color: #ff3838;
}
.pn-category .pn-span2 a {
  margin: 10px 15px 0 0;
}
.pn-category-menu {
  width: 1200px;
  height: 535px;
  overflow-y: scroll;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  left: -10px !important;
}
/*.pn-menu{height: 450px;overflow-y: auto;}*/
</style>

<script>
// import './global/css/font-awesome/css/font-awesome.min.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
import { CurrentEnvPrefix } from "config/urlprefix.js";
import { imgFallbackLittle } from "../../utils/fallbackImg";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import cookie from "vue-cookie";
import Cookies from "js-cookie";
export default {
  // props: {
  //   siteData: {
  //     type: Object,
  //     required: false,
  //     default: {}
  //   }
  // },
  data() {
    return {
      CurrentEnvPrefix,
      isshow: false,
      isshow1: -1,
      isshow2: -1,
      classlist: [],
      catelist: [],
      shoplist: [],
      siteData: {},
      siteDataObj: {},
      currentSite: {},
      siteTheme: {
        "1": {
          theme: "CS",
          icon: "/svg/cs.svg",
          site_icon: "/svg/cs_site.svg",
          site_logo: "/svg/cs_logo.svg",
          favicon: "/imgs/icons/cs_favicon.png"
        },
        "4": {
          theme: "ZL",
          icon: "/svg/zl.svg",
          site_icon: "/svg/zl_site.svg",
          site_logo: "/svg/zl_logo.svg",
          favicon: "/imgs/icons/zl_favicon.png"
        },
        "2": {
          theme: "GZ",
          icon: "/svg/gz.svg",
          site_icon: "/svg/gz_site.svg",
          site_logo: "/svg/gz_logo.svg",
          favicon: "/imgs/icons/gz_favicon.png"
        },
        "3": {
          theme: "ZS",
          icon: "/svg/zs.svg",
          site_icon: "/svg/zs_site.svg",
          site_logo: "/svg/zs_logo.svg",
          favicon: "/imgs/icons/zs_favicon.png"
        }
      },

      swiperOption: {
        autoplay: true,
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
        mousewheelControl: true
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    imgUrlLittle() {
      return imgFallbackLittle(this.Common.getSourec().sitehost);
    }
  },

  methods: {
    //一级下是否存在三级（无三级时弹层二级按三级样式平铺展示）
    hasThirdChild(list) {
      return (list.children || []).some(function(s) {
        return s.children && s.children.length > 0;
      });
    },
    showcategory() {
      this.isshow = true;
    },
    hiddencategory() {
      this.isshow = false;
    },
    showsubclass(index) {
      this.isshow1 = index;
    },
    hiddensubclass(index) {
      this.isshow1 = -1;
    },
    showsubclassItem(index) {
      this.isshow2 = index;
    },
    hiddensubclassItem(index) {
      this.isshow2 = -1;
    },
    getClassList() {
      // this.$Api.get({api:'/goods/goodsclass', param:{deep:3,has_ad:1}}).then(response => {
      // 	this.classlist=response.data.datas;
      // });
      this.$Api
        .get({
          api:
            this.Common.getSourec().plapi +
            "/goods_display_class/get_display_class_nav?SystemSiteId=" +
            (Cookies.get("SystemSiteId") || 1)
        })
        .then(response => {
          if (response.data.ResponseStatus == 0) {
            this.classlist = response.data.datas;
          }
        });
    },
    hrefClick(href) {
      this.$HrefRouter.WebHrefRrouter(href);
    },
    getNavShop() {
      this.$Api.get({ api: "/ad/newshop/list" }).then(response => {
        this.shoplist = response.data.datas;
      });
    },
    getSetList() {
      console.log(this.siteDataObj, 433435454);
      this.$Api
        .get({
          api: this.Common.getSourec().plapi + "/site/get_page_site_list"
        })
        .then(response => {
          if (response.data.ResponseStatus == 0) {
            this.siteData = response.data.datas;
            this.siteDataObj = this.siteData;
            let data = this.siteDataObj;
            let site_group = this.siteDataObj.site_group;
            let SystemSiteId = Cookies.get("SystemSiteId")
              ? Cookies.get("SystemSiteId")
              : data.site_id;
            let that = this;
            site_group.forEach(function(item, n, m) {
              item.children.forEach(function(i, n, m) {
                if (i.site_id == SystemSiteId) {
                  that.currentSite = {
                    ...that.currentSite,
                    ...that.siteTheme[i.color_type],
                    ...i,
                    ...item
                  };
                }
              });
            });
          }
        });
    }
  },
  // watch: {
  //   siteData: function(newVal, oldBal) {
  //     this.siteDataObj = newVal;
  //     let data = this.siteDataObj;
  //     let site_group = this.siteDataObj.site_group;
  //     let SystemSiteId = Cookies.get("SystemSiteId")
  //       ? Cookies.get("SystemSiteId")
  //       : data.site_id;
  //     let that = this;
  //     site_group.forEach(function(item, n, m) {
  //       item.children.forEach(function(i, n, m) {
  //         if (i.site_id == SystemSiteId) {
  //           that.currentSite = {
  //             ...that.currentSite,
  //             ...that.siteTheme[i.color_type],
  //             ...i,
  //             ...item
  //           };
  //         }
  //       });
  //     });
  //   }
  // },
  mounted() {
    this.getClassList();
    this.getNavShop();
    this.getSetList();
    var path = this.$route.path;
    var color_type = cookie.get("color_type") ? cookie.get("color_type") : "1";
    var color =
      color_type == "1"
        ? "#2357E8"
        : color_type == "2"
        ? "#FF5556"
        : color_type == "3"
        ? "#7A45E6"
        : color_type == "4"
        ? "#FC8200"
        : color_type == "6"
        ? "#2357E8"
        : "#2357E8";
    if (path == "/newgoods") {
      this.$refs.xbpa.style.color = color;
    } else if (path == "/hotsearch") {
      this.$refs.rbpa.style.color = color;
    } else if (path == "/brand") {
      this.$refs.ppya.style.color = color;
    } else if (path == "/navigation") {
      this.$refs.cja.style.color = color;
    } else if (path == "/wetchat") {
      this.$refs.wsa.style.color = color;
    } else if (path == "/seasongoods") {
      this.$refs.cxxp.style.color = color;
    } else if (path == "/newtowel") {
      // this.$refs.towel.style.color="#ff2d51";
    } else if (path == "/goodsupplier") {
      // this.$refs.yzsj.style.color="#ff2d51";
    } else if (path == "/topsupplier") {
      // this.$refs.sjyz.style.color="#ff2d51";
    } else if (path == "/purchase") {
      // this.$refs.wjcgj.style.color="#ff2d51";
    } else if (path == "/tianmao") {
      this.$refs.tm.style.color = color;
    } else if (path == "/yiqing") {
      this.$refs.yiqing.style.color = color;
    } else if (path == "/repeatwork") {
      this.$refs.repeatwork.style.color = color;
    } else if (path == "/findgoods") {
      this.$refs.fxhh.style.color = color;
    } else if (path == "/hotstore") {
      this.$refs.hotstore.style.color = color;
    } else if (path == "/jiafangcheng") {
      this.$refs.jiafangcheng.style.color = color;
    } else if (path == "/zhounian") {
      this.$refs.zhounian.style.color = color;
    } else if (path == "/channel") {
      this.$refs.channel.style.color = color;
    } else if (path == "/articlelist") {
      this.$refs.articlelist.style.color = color;
    } else if (path == "/videolist") {
      this.$refs.videolist.style.color = color;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/public/publicnav.vue